import { NavLink, useLocation } from 'react-router-dom'

import { useAuthMe } from '@/hooks/useAuth'
import { t } from '@/lib/i18n'
import styles from './Layout.module.css'

interface NavEntry {
  label: string
  to: string
  icon: string
}

const NAV_ENTRIES: NavEntry[] = [
  { label: t('Dashboard'), to: '/', icon: '◉' },
  { label: t('Projects'), to: '/projects', icon: '◎' },
  { label: t('Ledger'), to: '/ledger', icon: '▤' },
  { label: t('Monitors'), to: '/monitors', icon: '◈' },
  { label: t('Assets'), to: '/assets', icon: '◇' },
  { label: t('Incidents'), to: '/incidents', icon: '⚡' },
]

const PAGE_TITLES: Record<string, string> = {
  '/': t('Dashboard'),
  '/projects': t('Projects'),
  '/ledger': t('Ledger'),
  '/monitors': t('Monitors'),
  '/assets': t('Assets'),
  '/incidents': t('Incidents'),
  '/settings': t('Settings'),
}

export function Sidebar() {
  const { data: authMe } = useAuthMe()
  const email = authMe?.user?.email
  const initial = email ? email[0].toUpperCase() : ''

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebarLogo}>
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
          <rect width="22" height="22" rx="6" fill="var(--color-primary)" />
          <path d="M6 8h10v2H6zm0 4h7v2H6z" fill="#fff" opacity="0.9" />
        </svg>
        <span className="logoMark">Quay</span>
      </div>

      <nav className={styles.sidebarNav}>
        <div className={styles.sidebarSection}>{t('Operations')}</div>
        {NAV_ENTRIES.map((entry) => (
          <NavLink
            key={entry.to}
            to={entry.to}
            end={entry.to === '/'}
            className={({ isActive }) =>
              isActive
                ? `${styles.navItem} ${styles.navItemActive}`
                : styles.navItem
            }
          >
            <span className={styles.navIcon}>{entry.icon}</span>
            <span>{entry.label}</span>
          </NavLink>
        ))}

        <div className={styles.sidebarSection}>{t('Settings')}</div>
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem
          }
        >
          <span className={styles.navIcon}>⚙</span>
          <span>{t('Settings')}</span>
        </NavLink>
      </nav>

      <div className={styles.sidebarFooter}>
        <div className={styles.footerUser}>
          <span className={styles.footerAvatar}>{initial}</span>
          <span>{email ?? ''}</span>
        </div>
      </div>
    </aside>
  )
}

export function Header() {
  const { pathname } = useLocation()
  const { data: authMe } = useAuthMe()
  const title = PAGE_TITLES[pathname] ?? 'Quay'
  const email = authMe?.user?.email
  const initial = email ? email[0].toUpperCase() : ''

  return (
    <header className={styles.header}>
      <h1 className={styles.headerTitle}>{title}</h1>
      <div className={styles.headerRight}>
        <div className={styles.avatar}>{initial}</div>
      </div>
    </header>
  )
}
